import { getLocale } from "../runtime";

const sv_productusp4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Fri frakt över 599kr`
};

const productusp4 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_productusp4(inputs)
	return "productUsp4";
};

export { productusp4 as "productUsp4" };